import React from "react";
import { useTranslation } from "react-i18next";
import { Label } from "../../../../helpers/historyHelpers/components/Label";
import { OldValue } from "../../../../helpers/historyHelpers/components/OldValue";
import { NewValue } from "../../../../helpers/historyHelpers/components/NewValue";
import { firstToUpper } from "../../../../../../utils/helpers/string";
import { renderSettingsResourceLabel } from "../../../../../../utils/helpers/settings";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

const fields = [
    "allowedAllocationType",
    "allowedCompanies",
    "allowedPayGroups",
    "calcRule",
    "color",
    "defaultRate",
    "description",
    "earningGroup",
    "excludeFromPaidHours",
    "forAbsence",
    "forBreak",
    "forSchedule",
    "hourType",
    "includeForExport",
    "inputDurationAsNumber",
    "multiplier",
    "overridePayCodeOnReport",
    "extraRate",
    "status",
    "excludedCompanies",
    "includeOrExcludeAllocated",
    "inculdeForExport"
];

const RenderItem = ({ data }) => {
    const { t } = useTranslation();

    if (!data) return null;

    const renderValues = (item, data) => {
        const newValue = data[item]?.new;
        const oldValue = data[item]?.old;

        switch (item) {
            case "forBreak":
            case "forAbsence":
            case "forSchedule":
            case "inculdeForExport":
            case "excludeFromPaidHours":
            case "inputDurationAsNumber":
            case "overridePayCodeOnReport":
            case "includeOrExcludeAllocated":
                return (
                    <>
                        {typeof oldValue === "boolean" && (
                            <OldValue value={oldValue ? t("active") : t("not-active")} />
                        )}
                        {typeof newValue === "boolean" && (
                            <NewValue value={newValue ? t("active") : t("not-active")} />
                        )}
                    </>
                );
            case "color":
                return (
                    <>
                        <span
                            style={{
                                width: "55px",
                                height: "15px",
                                borderRadius: "4px",
                                backgroundColor: oldValue,
                            }}
                        />
                        <FontAwesomeIcon className="text-muted" icon={faArrowRight} />
                        <span
                            style={{
                                width: "55px",
                                height: "15px",
                                borderRadius: "4px",
                                backgroundColor: newValue,
                            }}
                        />
                    </>
                );
            case "earningGroup":
                return (
                    <>
                        {oldValue && <OldValue value={renderSettingsResourceLabel(oldValue)} />}
                        {newValue && <NewValue value={renderSettingsResourceLabel(newValue)} />}
                    </>
                );
            case "defaultRate":
            case "extraRate":
            case "multiplier":
                return (
                    <>
                        {typeof oldValue === "number" && <OldValue value={oldValue} />}
                        {typeof newValue === "number" && <NewValue value={newValue} />}
                    </>
                );
            case "status":
            case "allowedAllocationType":
            case "calcRule":
            case "description":
            case "hourType":
                return (
                    <>
                        {oldValue && <OldValue value={firstToUpper(t(oldValue))} />}
                        {newValue && <NewValue value={firstToUpper(t(newValue))} />}
                    </>
                );
            case "allowedCompanies":
            case "excludedCompanies":
                let oldAllowedCompanies = null;
                let newAllowedCompanies = null;

                if (oldValue?.length > 0) {
                    oldAllowedCompanies = (
                        <div className="d-flex flex-column justify-content-start align-items-start">
                            {oldValue.map((item) => (
                                <span>{item.name}</span>
                            ))}
                        </div>
                    );
                }
                if (newValue?.length > 0) {
                    newAllowedCompanies = (
                        <div className="d-flex flex-column justify-content-start align-items-start">
                            {newValue.map((item) => (
                                <span>{item.name}</span>
                            ))}
                        </div>
                    );
                }

                return (
                    <>
                        {oldAllowedCompanies && <OldValue value={oldAllowedCompanies} />}
                        {newAllowedCompanies && <NewValue value={newAllowedCompanies} />}
                    </>
                );
            case "allowedPayGroups":
                let oldAllowedPayGroups = null;
                let newAllowedPayGroups = null;

                if (oldValue?.length > 0) {
                    oldAllowedPayGroups = (
                        <div className="d-flex flex-column justify-content-start align-items-start">
                            {oldValue.map((item) => (
                                <span>{renderSettingsResourceLabel(item)}</span>
                            ))}
                        </div>
                    );
                }
                if (newValue?.length > 0) {
                    newAllowedPayGroups = (
                        <div className="d-flex flex-column justify-content-start align-items-start">
                            {newValue.map((item) => (
                                <span>{renderSettingsResourceLabel(item)}</span>
                            ))}
                        </div>
                    );
                }

                return (
                    <>
                        {oldAllowedPayGroups && <OldValue value={oldAllowedPayGroups} />}
                        {newAllowedPayGroups && <NewValue value={newAllowedPayGroups} />}
                    </>
                );

            default:
                return null;
        }
    };

    return (
        <div className="tooltip-content-style text-left">
            {fields?.map((item) => {
                if (!data[item]) return null;

                return (
                    <div key={item}>
                        <div className="py-1 d-flex align-items-center gap-2">
                            <Label value={t(item)} /> {renderValues(item, data)}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default RenderItem;
